module.exports = __webpack_public_path__ + "static/media/29BDOS6.5855d90f.jpg";